import axios from "axios";


export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

// Mock Interview / Elevator Pitch audio fields (responseAudioURL, questionAudioURL, audioURL)
// come back as paths relative to the API (e.g. "/interview/responses/12/audio") rather than
// absolute URLs -- they're streamed through our own backend instead of a direct Blob Storage
// link, so <audio>/<Audio> elements need the API origin prepended to actually resolve them.
export const apiMediaUrl = (path) => (path ? `${API_BASE_URL}${path}` : null);

const api = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
    // DB + Azure cold start can exceed 10s; status 0 often follows client-side abort.
    timeout: 60000,
    headers: {
        "Content-Type": "application/json",
    },
});


// Only one session verification at a time
let evictionCheck = null;

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Don't evict if already on login/signup page or public survey page
            const currentPath = window.location.pathname;
            if (currentPath === '/login' || currentPath === '/signup' || currentPath === '/' || currentPath === '/forgot-password' || currentPath.startsWith('/survey/')) {
                return Promise.reject(error);
            }

            const evict = () => {
                // Session is confirmed dead (or a stale cached user was
                // optimistically rendered). Clear the cached identity and tell
                // AuthContext to drop the user — the route guard in App.js
                // then soft-redirects to /login without a full page reload.
                console.warn("Session expired or unauthorized");
                localStorage.removeItem("user");
                window.dispatchEvent(new Event("auth:unauthorized"));
            };

            if ((error.config?.url || "").includes("/user/me")) {
                // /user/me itself rejected the session — authoritative.
                evict();
            } else if (!evictionCheck) {
                // A single endpoint 401 can be endpoint-specific noise; a
                // logged-in user must never be kicked out by it. Confirm
                // against /user/me and only evict if the session is dead.
                evictionCheck = api
                    .get("/user/me", { validateStatus: (s) => s === 200 || s === 401 })
                    .then((res) => { if (res.status === 401) evict(); })
                    .catch(() => { /* network hiccup — keep the session */ })
                    .finally(() => { evictionCheck = null; });
            }
        }
        return Promise.reject(error);
    }
);

export default api;